import request from '@/utils/request'

export function login (account, password) {
  return request({
    url: 'api/user/login',
    method: 'post',
    data: {
      account,
      password
    }
  })
}

export function register (regForm) {
  return request({
    url: 'api/user/register',
    method: 'post',
    data: regForm
  })
}

export function getInfo () {
  return request({
    url: 'api/index/index',
    method: 'get'
  })
}

export function getCodeImg () {
  return request({
    url: 'auth/code',
    method: 'get'
  })
}

export function logout () {
  return request({
    url: 'auth/logout',
    method: 'delete'
  })
}



